import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import Navbar from '../Navbar/Navbar';
import './HeroSection.css';

//hero section images
import FirstFloorFront1 from "../../assets/interior/First Floor Front Bed/Scene 3-1.png";
import GroundFloorInterior2 from "../../assets/interior/Ground floor interior/Document from M. Frasat(2).png";
import FirstFloorFront3 from "../../assets/interior/First Floor Front Bed/Scene 4-1.png";
import stairs1 from "../../assets/interior/stairs/FIrst floor & mazinine -2.jpg";
import GroundFloorMasterBed1 from "../../assets/interior/Ground floor Master Bed/Scene 1-1.png";

const HeroSection = () => {
  const navigate = useNavigate();
  const heroSectionRef = useRef(null);
  const [scrollProgress, setScrollProgress] = useState(0);

  const handleSelectHouse = () => {
    navigate('/showcase');
  };

  useEffect(() => {
    let scrollLocked = false;
    let scrollStartY = 0;
    let accumulatedScroll = 0;
    let animationComplete = false;
    const maxScrollDistance = 500; // Total scroll distance needed for animation (increased for smoother, more gradual changes)
    let animationFrameId = null;

    const handleWheel = (e) => {
      if (!heroSectionRef.current) return;

      const rect = heroSectionRef.current.getBoundingClientRect();
      const windowHeight = window.innerHeight;
      const windowWidth = window.innerWidth;

      // Target image dimensions - responsive (matches card 3 size)
      // Total width: 100vw - 60px (4 gaps) = cards width
      // Card 3 width: (100vw - 60px) / 5 + 2vw (largest, consistent with CSS)
      // Card progression: 1(-1vw) -> 2(base) -> 3(+2vw) -> 4(base) -> 5(-1vw)
      const gapTotal = 60; // 4 gaps of 15px
      const baseWidth = (windowWidth - gapTotal) / 5;
      const card3Width = baseWidth + (windowWidth * 0.02); // Base + 2vw (largest)
      const targetWidth = Math.max(260, Math.min(card3Width, windowWidth * 0.3)); // Responsive with limits
      const targetHeight = Math.max(windowHeight * 0.35, Math.min(windowHeight * 0.43, windowHeight * 0.52)); // Responsive: 35vh to 43vh, max 52vh

      // Check if section is in viewport
      const isInViewport = rect.top < windowHeight * 1.2 && rect.bottom > -windowHeight * 0.2;
      // Allow re-locking if scrolling back (animationComplete can be reset)
      const shouldLock = isInViewport && !scrollLocked && rect.top < windowHeight * 0.5 && rect.top > -100;

      if (shouldLock) {
        // Lock scroll when section enters viewport
        scrollLocked = true;
        // If animation was complete, reset it to allow reverse scrolling
        if (animationComplete) {
          animationComplete = false;
          // Set accumulatedScroll to max to start from the end when scrolling back
          accumulatedScroll = maxScrollDistance;
        } else {
          accumulatedScroll = 0;
        }
        scrollStartY = window.scrollY;
        document.body.style.overflow = 'hidden';
        document.body.style.position = 'fixed';
        document.body.style.width = '100%';
        document.body.style.top = `-${scrollStartY}px`;
      }

      if (scrollLocked) {
        e.preventDefault();
        e.stopPropagation();

        // Get wheel delta - preserve direction for reverse scrolling
        const delta = e.deltaY || e.detail || -e.wheelDelta;
        // Use actual delta (with sign) to support reverse scrolling
        // Positive delta = scroll down (increase progress), Negative delta = scroll up (decrease progress)
        accumulatedScroll += delta * 0.5; // Increased scroll speed

        // Clamp accumulated scroll
        accumulatedScroll = Math.max(0, Math.min(accumulatedScroll, maxScrollDistance));

        // Calculate progress (0 to 1)
        const progress = accumulatedScroll / maxScrollDistance;

        // Cancel previous animation frame
        if (animationFrameId) {
          cancelAnimationFrame(animationFrameId);
        }

        // Use requestAnimationFrame for smooth updates
        animationFrameId = requestAnimationFrame(() => {
          // Calculate width and height: start at 100vw/100vh, decrease to 450px/430px
          // Use easing for smoother transition
          const easedProgress = progress; // Can add easing function here if needed

          // Calculate current width and height
          const startWidth = windowWidth; // 100vw
          const startHeight = windowHeight; // 100vh
          const currentWidth = startWidth - (easedProgress * (startWidth - targetWidth));
          const currentHeight = startHeight - (easedProgress * (startHeight - targetHeight));

          // Calculate border radius: increases as image gets smaller
          const maxBorderRadius = 20;
          const borderRadius = easedProgress * maxBorderRadius;

          setScrollProgress(progress);

          // Apply width, height and border radius to image with smooth transition
          const bgImage = heroSectionRef.current.querySelector('.hero-background-image');
          if (bgImage) {
            bgImage.style.transition = 'width 0.1s ease-out, height 0.1s ease-out, border-radius 0.1s ease-out';
            bgImage.style.width = `${currentWidth}px`;
            bgImage.style.height = `${currentHeight}px`;
            bgImage.style.borderRadius = `${borderRadius}px`;
          }

          // Animate side cards sliding in - they appear as center image shrinks
          const leftCards = heroSectionRef.current.querySelectorAll('.hero-side-card-left');
          const rightCards = heroSectionRef.current.querySelectorAll('.hero-side-card-right');

          // Animate left cards (2 cards)
          leftCards.forEach((card, index) => {
            // Stagger animation: first card appears earlier
            const staggerDelay = index * 0.1; // Second card appears slightly later
            const slideProgress = Math.min(Math.max(0, (easedProgress - staggerDelay) * 1.2), 1);
            card.style.opacity = slideProgress;
            card.style.transform = `translateX(${-100 + (slideProgress * 100)}%)`;
          });

          // Animate right cards (2 cards)
          rightCards.forEach((card, index) => {
            // Stagger animation: first card appears earlier
            const staggerDelay = index * 0.1; // Second card appears slightly later
            const slideProgress = Math.min(Math.max(0, (easedProgress - staggerDelay) * 1.2), 1);
            card.style.opacity = slideProgress;
            card.style.transform = `translateX(${100 - (slideProgress * 100)}%)`;
          });

          // If animation is complete (forward), unlock scroll permanently
          // Only unlock when reaching the end (progress >= 1), not when scrolling back
          if (progress >= 1 && scrollLocked && accumulatedScroll >= maxScrollDistance) {
            scrollLocked = false;
            animationComplete = true;
            const finalScrollY = scrollStartY + maxScrollDistance;

            // Unlock immediately
            document.body.style.overflow = '';
            document.body.style.position = '';
            document.body.style.width = '';
            document.body.style.top = '';

            // Scroll to final position
            requestAnimationFrame(() => {
              window.scrollTo({ top: finalScrollY, behavior: 'auto' });
            });
          } else if (progress < 1 && animationComplete) {
            // If scrolling back before completion, reset the completion flag
            animationComplete = false;
          }
        });
      }
    };

    const handleScroll = () => {
      // Only update scroll progress when scroll is locked (during animation)
      // No animation effects on normal scroll
      if (!heroSectionRef.current || scrollLocked) return;

      // Reset scroll progress when not in locked animation
      setScrollProgress(0);
    };

    window.addEventListener('wheel', handleWheel, { passive: false });
    window.addEventListener('scroll', handleScroll, { passive: true });
    // No initial call - no animation on page load

    return () => {
      window.removeEventListener('wheel', handleWheel);
      window.removeEventListener('scroll', handleScroll);
      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId);
      }
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.width = '';
      document.body.style.top = '';
    };
  }, []);

  // Calculate width and height based on scroll progress
  // Target: responsive dimensions (matches card 3 size)
  const windowWidth = typeof window !== 'undefined' ? window.innerWidth : 1920;
  const windowHeight = typeof window !== 'undefined' ? window.innerHeight : 1080;
  // Calculate Card 3 width to match CSS: (100vw - 60px) / 5 + 2vw
  const gapTotal = 60; // 4 gaps of 15px
  const baseWidth = (windowWidth - gapTotal) / 5;
  const card3Width = baseWidth + (windowWidth * 0.02); // Base + 2vw (largest)
  const targetWidth = Math.max(260, Math.min(card3Width, windowWidth * 0.3)); // Responsive with limits
  const targetHeight = Math.max(windowHeight * 0.35, Math.min(windowHeight * 0.43, windowHeight * 0.52)); // Responsive: 35vh to 43vh, max 52vh

  // Width and height calculation: start at 100vw/100vh, decrease to 450px/430px
  // Only animates when scrolling (scrollProgress > 0)
  const startWidth = windowWidth;
  const startHeight = windowHeight;
  const currentWidth = startWidth - (scrollProgress * (startWidth - targetWidth));
  const currentHeight = startHeight - (scrollProgress * (startHeight - targetHeight));

  // Border radius increases as image gets smaller
  const maxBorderRadius = 20;
  const borderRadius = scrollProgress * maxBorderRadius;

  return (
    <div
      className="hero-section"
      ref={heroSectionRef}
    >
      {/* Cards Row Container - Left 2, Center, Right 2 in sequence */}
      <div className="hero-cards-row">
        {/* Left Side Card 1 - Smallest */}
        <div className="hero-side-card hero-side-card-left hero-side-card-1">
          <div className="hero-side-card-image">
            <img
              src={FirstFloorFront3}
              alt="Ground floor interior"
              className="hero-side-card-img"
            />
          </div>
        </div>

        {/* Left Side Card 2 - Medium */}
        <div className="hero-side-card hero-side-card-left hero-side-card-2">
          <div className="hero-side-card-image">
            <img
              src={FirstFloorFront1}
              alt="First floor front"
              className="hero-side-card-img"
            />
          </div>
        </div>

        {/* Center Hero Background Image */}
        <div
          className="hero-background-image"
          style={{
            width: `${currentWidth}px`,
            height: `${currentHeight}px`,
            borderRadius: `${borderRadius}px`,
          }}
        >
          <img
            src={GroundFloorInterior2}
            alt="Ground floor interior main"
            className="hero-background-img"
          />
          <div className="hero-overlay"></div>
        </div>

        {/* Right Side Card 1 - Medium */}
        <div className="hero-side-card hero-side-card-right hero-side-card-4">
          <div className="hero-side-card-image">
            <img
              src={GroundFloorMasterBed1}
              alt="Elevation option night view"
              className="hero-side-card-img"
            />
          </div>
        </div>

        {/* Right Side Card 2 - Smallest */}
        <div className="hero-side-card hero-side-card-right hero-side-card-5">
          <div className="hero-side-card-image">
            <img
              src={stairs1}
              alt="Elevation option day view"
              className="hero-side-card-img"
            />
          </div>
        </div>
      </div>


      <Navbar />

      <div className="hero-center-content">
        <h1 className="hero-main-title">
          Classic Villas - Your <em>Dream</em> Home
        </h1>

        <p className="hero-description">
          Design and build your perfect villa with our premium customization options. Create a home that reflects your style and lifestyle.
        </p>

        <button className="hero-select-house-btn" onClick={handleSelectHouse}>
          Start Building
        </button>
      </div>
    </div>
  );
};

export default HeroSection;
